"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useAppStore;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

/**
 * Provides a store for app-level data that is shared by all pages, such as
 * the main menu, nav, and footer items.
 * @param {Object} props Data fetched from `getInitialProps`, which should include an `appData` key.
 * @return {Array} A state and an updater function, similar to the result of React's `useState` hook.
 * The state will contain the value of `appData` returned by `getInitialProps`.
 */
function useAppStore(props) {
  var result = (0, _react.useState)(props.appData);

  var _result = (0, _slicedToArray2["default"])(result, 2),
      _ = _result[0],
      setState = _result[1];

  (0, _react.useEffect)(function () {
    if (props.appData) {
      setState(props.appData);
    }
  }, [props.appData]);
  return result;
}
//# sourceMappingURL=useAppStore.js.map